(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const desktopHover = window.matchMedia('(min-width: 1280px) and (hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const closeTimers = new WeakMap();
  const closeAnimations = new WeakMap();
  const openingAnimations = new WeakMap();
  let keyboardNavigation = false;
  const keepFocusedOpen = (dropdown) =>
    dropdown.contains(document.activeElement) &&
    (document.activeElement !== dropdown.querySelector('summary') || keyboardNavigation);
  const dropdownFrom = (target) =>
    target instanceof Element ? target.closest('.site-header .navigation-dropdown') : null;
  const cancelClose = (dropdown) => {
    clearTimeout(closeTimers.get(dropdown));
    closeTimers.delete(dropdown);
    closeAnimations.get(dropdown)?.cancel();
    closeAnimations.delete(dropdown);
  };
  const closeDropdown = (dropdown, animate = false) => {
    const panel = dropdown.querySelector(':scope > .navigation-submenu');
    const style = panel && animate ? getComputedStyle(panel) : null;
    const start = style ? { opacity: style.opacity, transform: style.transform } : null;
    cancelClose(dropdown);
    openingAnimations.get(dropdown)?.cancel();
    openingAnimations.delete(dropdown);
    if (!dropdown.open) return;
    if (!animate || reducedMotion.matches || !panel) {
      dropdown.open = false;
      return;
    }
    const animation = panel.animate(
      [
        start,
        { opacity: 0, transform: 'translateY(-5px)' },
      ],
      { duration: 140, easing: 'ease-out' },
    );
    closeAnimations.set(dropdown, animation);
    animation.finished
      .then(() => {
        if (closeAnimations.get(dropdown) !== animation) return;
        closeAnimations.delete(dropdown);
        dropdown.open = false;
      })
      .catch(() => {});
  };
  const closeOtherDropdowns = (dropdown) => {
    dropdown
      .closest('nav')
      .querySelectorAll('.navigation-dropdown[open]')
      .forEach((other) => {
        if (other !== dropdown) closeDropdown(other);
      });
  };
  const openDropdown = (dropdown) => {
    const panel = dropdown.querySelector(':scope > .navigation-submenu');
    const style = closeAnimations.has(dropdown) && panel ? getComputedStyle(panel) : null;
    const start = style ? { opacity: style.opacity, transform: style.transform } : null;
    cancelClose(dropdown);
    closeOtherDropdowns(dropdown);
    dropdown.open = true;
    if (!start || reducedMotion.matches) return;
    openingAnimations.get(dropdown)?.cancel();
    const animation = panel.animate(
      [start, { opacity: 1, transform: 'translateY(0)' }],
      { duration: 180, easing: 'ease-out', fill: 'both' },
    );
    openingAnimations.set(dropdown, animation);
    animation.finished.then(() => {
      if (openingAnimations.get(dropdown) !== animation) return;
      openingAnimations.delete(dropdown);
      animation.cancel();
    }).catch(() => {});
  };
  document.addEventListener('pointerover', (event) => {
    const dropdown = dropdownFrom(event.target);
    if (!desktopHover.matches || event.pointerType === 'touch' || !dropdown?.closest('.desktop-navigation')) return;
    if (dropdown.contains(event.relatedTarget)) return;
    const focusedDropdown = dropdownFrom(document.activeElement);
    if (focusedDropdown?.open && focusedDropdown !== dropdown && keepFocusedOpen(focusedDropdown)) return;
    openDropdown(dropdown);
  });
  document.addEventListener('pointerout', (event) => {
    const dropdown = dropdownFrom(event.target);
    if (!desktopHover.matches || event.pointerType === 'touch' || !dropdown?.closest('.desktop-navigation')) return;
    if (dropdown.contains(event.relatedTarget)) return;
    cancelClose(dropdown);
    closeTimers.set(
      dropdown,
      setTimeout(() => {
        if (!dropdown.matches(':hover') && !keepFocusedOpen(dropdown)) closeDropdown(dropdown, true);
      }, 180),
    );
  });
  document.addEventListener('click', (event) => {
    const summary =
      event.target instanceof Element
        ? event.target.closest('.desktop-navigation .navigation-dropdown > summary')
        : null;
    if (!desktopHover.matches || !summary || event.detail === 0) return;
    event.preventDefault();
    openDropdown(summary.parentElement);
  });
  document.addEventListener(
    'toggle',
    (event) => {
      const dropdown = dropdownFrom(event.target);
      if (!dropdown || dropdown !== event.target) return;
      if (dropdown.open) closeOtherDropdowns(dropdown);
      else cancelClose(dropdown);
    },
    true,
  );
  document.addEventListener('focusin', (event) => {
    const dropdown = dropdownFrom(event.target);
    if (dropdown?.open) openDropdown(dropdown);
  });
  document.addEventListener('focusout', (event) => {
    const dropdown = dropdownFrom(event.target);
    if (!dropdown || dropdown.contains(event.relatedTarget)) return;
    requestAnimationFrame(() => {
      if (!dropdown.matches(':hover') && !dropdown.contains(document.activeElement)) closeDropdown(dropdown);
    });
  });
  document.addEventListener('keydown', (event) => {
    if (['Tab', 'Enter', ' '].includes(event.key)) keyboardNavigation = true;
    if (event.key !== 'Escape') return;
    const disclosure = event.target instanceof Element ? event.target.closest('.site-header details[open]') : null;
    if (!disclosure) return;
    disclosure.querySelectorAll('details[open]').forEach((child) => closeDropdown(child));
    closeDropdown(disclosure);
    disclosure.querySelector('summary').focus();
    event.preventDefault();
  });
  document.addEventListener('pointerdown', (event) => {
    keyboardNavigation = false;
    if (event.target instanceof Element && event.target.closest('.site-header')) return;
    document.querySelectorAll('.site-header details[open]').forEach((disclosure) => closeDropdown(disclosure));
  });
  const estateAnchorTarget = (hash) => {
    if (!hash) return null;
    try {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      return target?.matches('.estate-guide[id]') ? target : null;
    } catch {
      return null;
    }
  };
  const markEstateLocation = () => {
    document.querySelectorAll('.site-header [data-estate-anchor-link]').forEach((link) => {
      const destination = new URL(link.href, location.href);
      link.removeAttribute('aria-current');
      if (destination.origin !== location.origin || destination.pathname !== location.pathname) return;
      if (destination.hash === location.hash) link.setAttribute('aria-current', destination.hash ? 'location' : 'page');
    });
  };
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element ? event.target.closest('.site-header a[href]') : null;
    if (!link || link.target === '_blank') return;
    const destination = new URL(link.href, location.href);
    document.querySelectorAll('.site-header details[open]').forEach((disclosure) => closeDropdown(disclosure));
    if (destination.origin !== location.origin || destination.pathname !== location.pathname || destination.search !== location.search) return;
    estateAnchorTarget(destination.hash)?.focus({ preventScroll: true });
  });
  window.addEventListener('hashchange', markEstateLocation);
  markEstateLocation();
  desktopHover.addEventListener('change', () => {
    document.querySelectorAll('.site-header details[open]').forEach((disclosure) => closeDropdown(disclosure));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const cartControllers = new Map();
  const canonicalProperties = (properties) => {
    const values = Array.isArray(properties) ? Object.fromEntries(properties.filter((entry) => Array.isArray(entry) && entry.length >= 2)) : properties || {};
    return JSON.stringify(Object.entries(values).sort(([left], [right]) => left.localeCompare(right)));
  };
  const lineSignature = (variant, properties, sellingPlan) => `${variant}|${canonicalProperties(properties)}|${sellingPlan || ''}`;
  const signatureFromElement = (line) => {
    let properties = {};
    try { properties = JSON.parse(line.dataset.cartProperties || '{}'); } catch {}
    return lineSignature(line.dataset.cartVariant, properties, line.dataset.cartSellingPlan);
  };
  const signatureFromItem = (item) => lineSignature(item.variant_id || item.id, item.properties, item.selling_plan_allocation?.selling_plan?.id);
  const findItem = (items, entry) => {
    const sameKey = items.find((item) => item.key === entry.key);
    if (sameKey) return sameKey;
    const matches = items.filter((item) => signatureFromItem(item) === entry.signature);
    return matches.length === 1 ? matches[0] : null;
  };
  const validateCartQuantity = (input) => {
    input.setCustomValidity('');
    const quantity = input.valueAsNumber;
    const minimum = Number(input.dataset.minimum) || 1;
    const increment = Number(input.step) || 1;
    if (quantity > 0 && (quantity < minimum || quantity % increment !== 0)) {
      input.setCustomValidity(input.dataset.quantityError);
    }
    input.setAttribute('aria-invalid', String(!input.validity.valid));
    return input.validity.valid && Number.isInteger(quantity);
  };
  const createCartController = (initialRoot) => {
    const commerce = window.ChateauCommerce;
    const sectionId = initialRoot.dataset.sectionId;
    let root = initialRoot;
    let noteDraft = root.querySelector('[data-cart-note]')?.value || '';
    let savedNote = noteDraft;
    let noteVersion = 0;
    let notePending = false;
    let running = null;
    let timer;
    let needsReconcile = false;
    let uncertainMutation = false;
    let checkoutIntent = false;
    let allowCheckout = false;
    let failed = false;
    let replacing = false;
    const drafts = new Map();
    const currentLine = (entry) => {
      const lines = [...root.querySelectorAll('[data-cart-line]')];
      const sameKey = lines.find((line) => line.dataset.cartKey === entry.key);
      if (sameKey) return sameKey;
      const matches = lines.filter((line) => signatureFromElement(line) === entry.signature);
      return matches.length === 1 ? matches[0] : null;
    };
    const setMessage = (message = '', error = false) => {
      const status = root.querySelector('[data-cart-status]');
      const errorNode = root.querySelector('[data-cart-error]');
      const view = commerce.captureView(root);
      try {
        if (status) status.textContent = error ? '' : message;
        if (errorNode) {
          errorNode.hidden = !error;
          errorNode.textContent = error ? message : '';
        }
      } finally {
        commerce.restoreView(view, root);
      }
    };
    const setBusy = (busy) => {
      root.setAttribute('aria-busy', String(busy));
      root.querySelectorAll('[name="checkout"]').forEach((button) => { button.disabled = checkoutIntent; });
      if (busy) setMessage(root.dataset.cartUpdating);
    };
    const rememberQuantity = (input, force = false) => {
      if (replacing || !input.isConnected || input.closest('[data-cart-section]') !== root) return false;
      if (uncertainMutation) {
        setMessage(root.dataset.cartNetworkError, true);
        return false;
      }
      const line = input.closest('[data-cart-line]');
      if (!line) return false;
      const previous = [...drafts.values()].find((entry) => entry.key === line.dataset.cartKey);
      const token = previous?.token || line.dataset.cartKey;
      const valid = validateCartQuantity(input);
      drafts.set(token, {
        token,
        key: line.dataset.cartKey,
        signature: signatureFromElement(line),
        value: input.value,
        quantity: input.valueAsNumber,
        version: (previous?.version || 0) + 1,
        pending: valid && (force || input.valueAsNumber !== Number(input.dataset.cartSavedQuantity))
      });
      if (!valid) setMessage(input.validationMessage || root.dataset.cartUpdateError, true);
      return valid;
    };
    const remapDrafts = (cart) => {
      let missingLine = false;
      for (const [token, entry] of drafts) {
        const item = findItem(cart.items || [], entry);
        if (item) {
          entry.key = item.key;
        } else {
          drafts.delete(token);
          if (entry.pending && entry.quantity !== 0) missingLine = true;
        }
      }
      return missingLine;
    };
    const restoreDrafts = () => {
      for (const entry of drafts.values()) {
        const input = currentLine(entry)?.querySelector('[data-cart-quantity]');
        if (input) {
          input.value = entry.value;
          validateCartQuantity(input);
        }
      }
      const note = root.querySelector('[data-cart-note]');
      if (note) note.value = noteDraft;
    };
    const renderCart = async (cart) => {
      commerce.publishCart(cart);
      let html = cart.sections?.[sectionId];
      if (!html) {
        const sections = await commerce.fetchSections(window.location.pathname + window.location.search, [sectionId]);
        html = sections?.[sectionId];
      }
      const parsed = html ? new DOMParser().parseFromString(html, 'text/html') : null;
      const replacement = parsed?.querySelector(`[data-cart-section][data-section-id="${CSS.escape(sectionId)}"]`);
      if (!replacement) throw Object.assign(new Error(root.dataset.cartRenderError), { renderError: true });
      const view = commerce.captureView(root);
      const active = document.activeElement;
      const activeLine = active?.closest('[data-cart-line]');
      const lineIndex = activeLine ? [...root.querySelectorAll('[data-cart-line]')].indexOf(activeLine) : -1;
      const activeEntry = activeLine ? { key: activeLine.dataset.cartKey, signature: signatureFromElement(activeLine) } : null;
      const activeKind = active?.matches('[data-cart-quantity]') ? 'quantity' : active?.matches('[data-cart-remove]') ? 'remove' : null;
      const missingLine = remapDrafts(cart);
      replacing = true;
      try {
        root.replaceWith(replacement);
        root = replacement;
        adopt(root);
        restoreDrafts();
        savedNote = cart.note || '';
        let focusSelector;
        if (activeEntry && activeKind) {
          const item = findItem(cart.items || [], activeEntry);
          const lines = [...root.querySelectorAll('[data-cart-line]')];
          const line = item ? lines.find((node) => node.dataset.cartKey === item.key) : lines[Math.min(lineIndex, lines.length - 1)];
          if (line) focusSelector = `[data-cart-key="${CSS.escape(line.dataset.cartKey)}"] [data-cart-${activeKind === 'quantity' ? 'quantity' : 'remove'}]`;
          else focusSelector = '[data-cart-empty]';
        } else if (active?.matches('[data-cart-note]')) focusSelector = '[data-cart-note]';
        else if (active?.name === 'update') focusSelector = '[name="update"]';
        else if (active?.name === 'checkout') focusSelector = '[name="checkout"]';
        commerce.restoreView(view, root, { focusSelector });
      } finally {
        replacing = false;
      }
      if (missingLine) {
        failed = true;
        setMessage(root.dataset.cartUpdateError, true);
      }
      document.dispatchEvent(new CustomEvent('chateau:commerce:updated', { detail: { root } }));
    };
    const reconcile = async () => {
      const cart = await commerce.request(commerce.cartEndpoint(''));
      await renderCart(cart);
      needsReconcile = false;
      return cart;
    };
    const handleFailure = async (error) => {
      failed = true;
      uncertainMutation = uncertainMutation || Boolean(error.uncertain);
      clearTimeout(timer);
      drafts.clear();
      notePending = false;
      needsReconcile = true;
      const message = error.renderError ? root.dataset.cartRenderError : error.uncertain ? root.dataset.cartNetworkError : error.data?.description || error.message || root.dataset.cartUpdateError;
      try { await reconcile(); } catch {}
      setMessage(message, true);
    };
    const process = () => {
      clearTimeout(timer);
      if (uncertainMutation) {
        setMessage(root.dataset.cartNetworkError, true);
        return Promise.resolve(false);
      }
      if (running) return running;
      const hasPending = [...drafts.values()].some((entry) => entry.pending) || notePending;
      if (!hasPending && !needsReconcile) return Promise.resolve(true);
      failed = false;
      setBusy(true);
      running = commerce.enqueue(async () => {
        try {
          if (needsReconcile) await reconcile();
          while (true) {
            const entry = [...drafts.values()].find((candidate) => candidate.pending);
            if (entry) {
              const line = currentLine(entry);
              if (!line) throw new Error(root.dataset.cartUpdateError);
              const requestVersion = entry.version;
              const requestedQuantity = entry.quantity;
              const cart = await commerce.request(commerce.cartEndpoint('change'), {
                method: 'POST',
                body: { id: line.dataset.cartKey, quantity: requestedQuantity, sections: [sectionId], sections_url: window.location.pathname + window.location.search }
              });
              const latest = drafts.get(entry.token);
              if (latest?.version === requestVersion) drafts.delete(entry.token);
              await renderCart(cart);
              const item = requestedQuantity === 0 ? null : findItem(cart.items || [], entry);
              if (requestedQuantity > 0 && item?.quantity !== requestedQuantity) {
                failed = true;
                setMessage(root.dataset.cartUpdateError, true);
              }
              continue;
            }
            if (notePending && noteDraft !== savedNote) {
              const requestVersion = noteVersion;
              const cart = await commerce.request(commerce.cartEndpoint('update'), {
                method: 'POST',
                body: { note: noteDraft, sections: [sectionId], sections_url: window.location.pathname + window.location.search }
              });
              if (requestVersion === noteVersion) notePending = false;
              await renderCart(cart);
              continue;
            }
            notePending = false;
            break;
          }
          if (!failed) setMessage(root.dataset.cartUpdated);
          return !failed;
        } catch (error) {
          await handleFailure(error);
          return false;
        } finally {
          setBusy(false);
        }
      }).finally(() => { running = null; });
      return running;
    };
    const validateForm = () => {
      const invalid = [...root.querySelectorAll('[data-cart-quantity]')].find((input) => !validateCartQuantity(input));
      if (!invalid) return true;
      setMessage(invalid.validationMessage || root.dataset.cartUpdateError, true);
      invalid.focus({ preventScroll: true });
      return false;
    };
    const rememberAll = () => {
      root.querySelectorAll('[data-cart-quantity]').forEach((input) => rememberQuantity(input));
      noteDraft = root.querySelector('[data-cart-note]')?.value || noteDraft;
      notePending = noteDraft !== savedNote;
    };
    const handleSubmit = async (event) => {
      if (uncertainMutation) {
        event.preventDefault();
        setMessage(root.dataset.cartNetworkError, true);
        return;
      }
      if (allowCheckout && event.submitter?.name === 'checkout') return;
      event.preventDefault();
      if (checkoutIntent) return;
      if (!validateForm()) return;
      rememberAll();
      if (event.submitter?.name !== 'checkout') {
        await process();
        return;
      }
      checkoutIntent = true;
      setBusy(true);
      const success = await process();
      await new Promise((resolve) => setTimeout(resolve, 0));
      checkoutIntent = false;
      setBusy(false);
      if (!success || !validateForm() || !root.querySelector('[data-cart-form]')) return;
      allowCheckout = true;
      const form = root.querySelector('[data-cart-form]');
      form.requestSubmit(form.querySelector('[name="checkout"]'));
      allowCheckout = false;
    };
    const adopt = (nextRoot) => {
      root = nextRoot;
      if (root.dataset.cartBound === 'true') return;
      root.dataset.cartBound = 'true';
      const form = root.querySelector('[data-cart-form]');
      if (form) {
        form.noValidate = true;
        form.addEventListener('submit', handleSubmit);
      }
      root.querySelectorAll('[data-cart-quantity]').forEach((input) => {
        validateCartQuantity(input);
        input.addEventListener('input', () => {
          if (replacing || !input.isConnected) return;
          rememberQuantity(input);
          clearTimeout(timer);
          if (input.validity.valid) timer = setTimeout(process, 350);
        });
        input.addEventListener('change', () => {
          if (rememberQuantity(input)) process();
        });
      });
      root.querySelectorAll('[data-cart-remove]').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          if (uncertainMutation) {
            setMessage(root.dataset.cartNetworkError, true);
            return;
          }
          const input = link.closest('[data-cart-line]')?.querySelector('[data-cart-quantity]');
          if (!input) return;
          input.value = '0';
          rememberQuantity(input, true);
          process();
        });
      });
      const note = root.querySelector('[data-cart-note]');
      note?.addEventListener('input', () => {
        if (replacing || !note.isConnected || note.closest('[data-cart-section]') !== root) return;
        noteDraft = note.value;
        noteVersion += 1;
      });
      note?.addEventListener('change', () => {
        if (replacing || !note.isConnected || note.closest('[data-cart-section]') !== root) return;
        notePending = noteDraft !== savedNote;
        process();
      });
      root.setAttribute('aria-busy', String(Boolean(running)));
    };
    adopt(root);
    return { adopt };
  };
  const bindCart = (scope) => {
    const roots = [...scope.querySelectorAll('[data-cart-section]')];
    if (scope.matches?.('[data-cart-section]')) roots.unshift(scope);
    roots.forEach((root) => {
      if (!window.ChateauCommerce) return;
      const sectionId = root.dataset.sectionId;
      if (cartControllers.has(sectionId)) cartControllers.get(sectionId).adopt(root);
      else cartControllers.set(sectionId, createCartController(root));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bindCart(document));
  else bindCart(document);
  document.addEventListener('shopify:section:load', (event) => bindCart(event.target));
  document.addEventListener('chateau:commerce:ready', () => bindCart(document));
  document.addEventListener('chateau:commerce:updated', (event) => bindCart(event.detail?.root || document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.chateauProductCommerceReady) return;
    window.chateauProductCommerceReady = true;
    const states = new WeakMap();
    const stateFor = (root) => {
      if (!states.has(root)) states.set(root, { busy: false, version: 0, controller: null, blocked: false, uncertain: false });
      return states.get(root);
    };
    const text = (root, key) => root.querySelector(`[data-product-commerce-text="${key}"]`)?.textContent.trim() || '';
    const message = (root, status = '', error = '', showCart = false) => {
      const container = root.querySelector('[data-product-commerce-message]');
      if (!container) return;
      const commerce = window.ChateauCommerce;
      const view = commerce.captureView(root);
      container.hidden = !status && !error;
      container.querySelector('[data-product-commerce-status]').textContent = status;
      const alert = container.querySelector('[data-product-commerce-error]');
      alert.hidden = !error;
      alert.textContent = error;
      container.querySelector('[data-product-commerce-cart]').hidden = !showCart;
      commerce.restoreView(view, root);
    };
    const backendError = (error) => {
      if (typeof error.data?.description === 'string') return error.data.description;
      if (typeof error.data?.message === 'string') return error.data.message;
      return '';
    };
    const productURL = (root, variant = root.dataset.selectedVariant) => {
      const url = new URL(location.href);
      url.searchParams.set('variant', variant);
      url.searchParams.delete('sections');
      url.searchParams.delete('section_id');
      return url;
    };
    const lock = (root, keepVariant = false) => {
      const controls = [...root.querySelectorAll('[data-product-buy-region] input, [data-product-buy-region] select, [data-product-buy-region] button')]
        .filter((control) => !keepVariant || !control.matches('[data-variant-selector]'));
      const disabled = controls.map((control) => [control, control.disabled]);
      controls.forEach((control) => { control.disabled = true; });
      root.querySelectorAll('[data-product-buy-region]').forEach((region) => region.setAttribute('aria-busy', 'true'));
      const payments = [...root.querySelectorAll('.shopify-payment-button')].map((element) => [element, element.inert]);
      payments.forEach(([element]) => { element.inert = true; });
      return () => {
        disabled.forEach(([control, wasDisabled]) => { if (control.isConnected) control.disabled = wasDisabled; });
        payments.forEach(([element, wasInert]) => { if (element.isConnected) element.inert = wasInert; });
        root.querySelectorAll('[data-product-buy-region]').forEach((region) => region.removeAttribute('aria-busy'));
      };
    };
    const activeSelector = (root) => {
      const active = document.activeElement;
      if (!root.contains(active)) return '';
      if (active.id) return `#${CSS.escape(active.id)}`;
      if (active.matches('.product-add')) return '.product-add';
      return '';
    };
    const renderCommerce = (root, html, expectedVariant, quantityValue, previousFocus = '') => {
      if (typeof html !== 'string') throw new Error('Missing product section');
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-product-commerce]');
      if (!next || next.dataset.sectionId !== root.dataset.sectionId || next.dataset.selectedVariant !== String(expectedVariant)) {
        throw new Error('Invalid product section');
      }
      const regions = [...root.querySelectorAll('[data-product-buy-region]')];
      const replacements = regions.map((region) => [...next.querySelectorAll('[data-product-buy-region]')]
        .find((replacement) => replacement.dataset.productBuyRegion === region.dataset.productBuyRegion));
      if (!regions.length || replacements.some((replacement) => !replacement)) throw new Error('Incomplete product section');
      const commerce = window.ChateauCommerce;
      const view = commerce.captureView(root);
      const focusSelector = activeSelector(root) || (document.activeElement === document.body ? previousFocus : '');
      if (focusSelector && document.activeElement === document.body) view.inside = true;
      regions.forEach((region, index) => { region.innerHTML = replacements[index].innerHTML; });
      root.dataset.selectedVariant = next.dataset.selectedVariant;
      const quantity = root.querySelector('[data-product-add-form] input[name="quantity"]');
      if (quantity && !quantity.disabled && quantityValue !== undefined) {
        const initial = quantity.value;
        quantity.value = String(quantityValue);
        if (!quantity.validity.valid) quantity.value = initial;
      }
      document.dispatchEvent(new CustomEvent('chateau:commerce:updated', { detail: { root } }));
      quantity?.dispatchEvent(new Event('input', { bubbles: true }));
      window.Shopify?.PaymentButton?.init?.();
      commerce.restoreView(view, root, { focusSelector });
    };
    const refreshCommerce = async (root, quantityValue, previousFocus = '') => {
      const commerce = window.ChateauCommerce;
      const sections = await commerce.fetchSections(productURL(root), [root.dataset.sectionId]);
      renderCommerce(root, sections[root.dataset.sectionId], root.dataset.selectedVariant, quantityValue, previousFocus);
    };
    document.addEventListener('change', async (event) => {
      const select = event.target.closest('[data-variant-selector]');
      const root = select?.closest('[data-product-commerce]');
      const commerce = window.ChateauCommerce;
      if (!root || !commerce) return;
      const state = stateFor(root);
      if (state.busy) {
        select.value = root.dataset.selectedVariant;
        return;
      }
      state.controller?.abort();
      const version = ++state.version;
      const controller = new AbortController();
      state.controller = controller;
      state.unlock?.();
      const previousFocus = activeSelector(root);
      const unlock = lock(root, true);
      state.unlock = unlock;
      const quantityValue = root.querySelector('input[name="quantity"]')?.value;
      const variant = select.value;
      const url = productURL(root, variant);
      message(root, text(root, 'loading'));
      try {
        const sections = await commerce.fetchSections(url, [root.dataset.sectionId], { signal: controller.signal });
        if (version !== state.version || !root.isConnected) return;
        renderCommerce(root, sections[root.dataset.sectionId], variant, quantityValue, previousFocus);
        history.replaceState(history.state, '', url);
        state.blocked = false;
        message(root);
      } catch (error) {
        if (version !== state.version || error.name === 'AbortError') return;
        select.value = root.dataset.selectedVariant;
        message(root, '', text(root, 'variant_error'));
      } finally {
        if (version === state.version) {
          unlock();
          state.unlock = null;
          state.controller = null;
        }
      }
    });
    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-product-add-form]');
      const root = form?.closest('[data-product-commerce]');
      const commerce = window.ChateauCommerce;
      if (!root || !commerce) return;
      if (event.submitter && !event.submitter.matches('.product-add')) return;
      event.preventDefault();
      const state = stateFor(root);
      if (state.busy || state.controller) return;
      if (state.blocked || state.uncertain) {
        message(root, '', text(root, 'sync_error'), true);
        return;
      }
      if (form.querySelector('.product-add')?.disabled || form.querySelector('input[name="quantity"]')?.disabled) return;
      if (!form.reportValidity()) return;
      const body = new FormData(form);
      const variant = body.get('id');
      if (String(variant) !== root.dataset.selectedVariant) return;
      const previousFocus = activeSelector(root);
      body.set('sections', root.dataset.sectionId);
      const context = productURL(root);
      body.set('sections_url', context.pathname + context.search);
      state.busy = true;
      const unlock = lock(root);
      message(root, text(root, 'loading'));
      commerce.enqueue(async () => {
        let added = false;
        let refreshed = false;
        try {
          const response = await commerce.request(commerce.cartEndpoint('add'), { method: 'POST', body });
          added = true;
          try {
            renderCommerce(root, response.sections?.[root.dataset.sectionId], variant, undefined, previousFocus);
            refreshed = true;
          } catch {
            await refreshCommerce(root, undefined, previousFocus);
            refreshed = true;
          }
          const cart = await commerce.request(commerce.cartEndpoint(''));
          commerce.publishCart(cart);
          message(root, text(root, 'added'), '', true);
        } catch (error) {
          if (!added && error.uncertain) state.uncertain = true;
          try {
            const cart = await commerce.request(commerce.cartEndpoint(''));
            commerce.publishCart(cart);
          } catch {}
          if (!refreshed) {
            try {
              await refreshCommerce(root, added ? undefined : body.get('quantity'), previousFocus);
              refreshed = true;
            } catch {}
          }
          if (added) {
            message(root, text(root, 'added'), text(root, 'refresh_error'), true);
          } else {
            message(root, '', backendError(error) || text(root, error.uncertain ? 'uncertain' : 'error'), true);
          }
        } finally {
          state.blocked = !refreshed;
          unlock();
          if (!refreshed && previousFocus && document.activeElement === document.body) {
            const view = commerce.captureView(root);
            view.inside = true;
            commerce.restoreView(view, root, { focusSelector: previousFocus });
          }
          state.busy = false;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-chapters"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const markChapter = () => {
      document.querySelectorAll('.page-chapters__link').forEach((link) => {
        link.removeAttribute('aria-current');
        if (link.hash === location.hash) link.setAttribute('aria-current', 'location');
      });
    };
    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target instanceof Element ? event.target.closest('.page-chapters__link') : null;
      if (!link) return;
      document.getElementById(link.hash.slice(1))?.focus({ preventScroll: true });
    });
    window.addEventListener('hashchange', markChapter);
    document.addEventListener('shopify:section:load', markChapter);
    markChapter();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertical-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const players = new Map();
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const autoAllowed = (root) => root.dataset.autoplay === 'true' && !reducedMotion.matches && !navigator.connection?.saveData && !window.Shopify?.designMode;
    const initialize = (scope = document) => {
      const roots = [...scope.querySelectorAll('[data-vertical-film]')];
      if (scope.matches?.('[data-vertical-film]')) roots.unshift(scope);
      roots.forEach((root) => {
        if (players.has(root)) return;
        const video = root.querySelector('video');
        const button = root.querySelector('.vertical-film__toggle');
        if (!video || !button) return;
        const state = { visible: false, resume: autoAllowed(root), observer: null };
        players.set(root, { video, state });
        const sync = () => {
          button.classList.toggle('is-playing', !video.paused);
          button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        };
        const play = () => video.play().catch(() => { state.resume = false; sync(); });
        button.hidden = false;
        button.addEventListener('click', () => {
          if (video.paused) { state.resume = true; play(); }
          else { state.resume = false; video.pause(); }
          sync();
        });
        video.addEventListener('play', () => {
          for (const [otherRoot, other] of players) {
            if (otherRoot !== root) { other.state.resume = false; other.video.pause(); }
          }
          sync();
        });
        video.addEventListener('pause', () => {
          if (state.visible && !document.hidden) state.resume = false;
          sync();
        });
        video.addEventListener('ended', () => { state.resume = false; sync(); });
        video.addEventListener('error', () => {
          root.querySelector('.vertical-film__error').hidden = false;
          button.disabled = true;
          state.resume = false;
        });
        if ('IntersectionObserver' in window) {
          state.observer = new IntersectionObserver(([entry]) => {
            state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.3;
            if (!state.visible) video.pause();
            else if (state.resume && autoAllowed(root) && !document.hidden) play();
          }, { threshold: [0, 0.3] });
          state.observer.observe(video);
        }
        sync();
      });
    };
    const pauseAll = () => {
      for (const { video } of players.values()) video.pause();
    };
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pauseAll();
    });
    reducedMotion.addEventListener('change', () => {
      if (reducedMotion.matches) {
        for (const { video, state } of players.values()) { state.resume = false; video.pause(); }
      }
    });
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      for (const [root, { video, state }] of players) {
        if (event.target.contains(root)) { state.observer?.disconnect(); video.pause(); players.delete(root); }
      }
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    else initialize();
  })();

  } catch(e) { console.error(e); }
})();
})();
